export namespace OrderTranslations {
  export const common = {
    order: 'order',
    swapStockLocations: 'swapStockLocations',
    quickOrder: 'quickOrder',
  } as const;

  export const error = {
    ordersUnableToLoadError: 'ordersUnableToLoadError',
    orderFlowsUnableToLoadError: 'orderFlowsUnableToLoadError',
    orderStatusesUnableToLoadError: 'orderStatusesUnableToLoadError',
    productTransactionStatusesUnableToLoadError: 'productTransactionStatusesUnableToLoadError',
    productStatusesUnableToLoadError: 'productStatusesUnableToLoadError',

    selectSourceProductsQuantityForProductExceedsAvailableQuantityError:
      'selectSourceProductsQuantityForProductExceedsAvailableQuantityError',
  } as const;

  export const orders = {
    disposal: 'disposal',
    disposalOrder: 'disposalOrder',
    disposalTooltip: 'disposalTooltip',

    createQuickOrder: 'createQuickOrder',
    createQuickOrderDescription: 'createQuickOrderDescription',

    cannotEditProductsForOrderWarningTitle: 'cannotEditProductsForOrderWarningTitle',
    cannotEditProductsForOrderTypeWarningDescription: 'cannotEditProductsForOrderTypeWarningDescription',

    orderCreatedToastTitle: 'orderCreatedToastTitle',
    orderCreatedToastContentClickToStart: 'orderCreatedToastContentClickToStart',
  } as const;
}
